'use strict';

const VERSION = '1.0.0';
const NAME = 'scripts-product';

let addToCartForm, sizeRadios;
let multiplier = 1;

function init(options) {
    console.log(NAME, 'init');

    addToCartForm = document.querySelector(`form[name='addToCart']`);
    if (!addToCartForm) {
        return;
    }

    addToCartForm.querySelectorAll(`select`).forEach(select => {
        select.addEventListener('change', evt => {
            // console.log('data-select', 'change', evt.target, evt.currentTarget);
            updateUI()
        });
    });

    addToCartForm.addEventListener('submit', evt => {
        let addToCartButton = evt.target.querySelector(`button[type='submit']`);
        if (addToCartButton) {
            addToCartButton.classList.add('is-hidden');
            addToCartButton.parentNode.querySelector('progress.progress').classList.remove('is-hidden');
        }
    });

    addToCartForm.querySelectorAll('input[name="giftsIds"][type="checkbox"]').forEach(element => {
        element.addEventListener('change', evt => {
            updateUI()
        });
    });

    addToCartForm.querySelectorAll('input[name="size"][type="radio"]').forEach(element => {
        element.addEventListener('change', evt => {
            updateUI()
        });
    });

    updateUI();
}

function updateUI() {
    let price = 0;

    let priceData = addToCartForm.querySelector(`.price[data-price]`);
    if (priceData) {
        price = parseFloat(priceData.getAttribute('data-price'));
    } else {
        return;
    }

    let quantitySelect = addToCartForm.querySelector(`select[name="quantity"]`);
    if (quantitySelect) {
        price = parseFloat(quantitySelect.options[quantitySelect.selectedIndex].getAttribute('data-price'));
    }

    let spendSelect = addToCartForm.querySelector(`select[name="spend"]`);
    if (spendSelect) {
        price = parseFloat(spendSelect.options[spendSelect.selectedIndex].getAttribute('data-price'));
    }

    let giftsTotal = 0;
    addToCartForm.querySelectorAll(`[name='giftsIds']:checked`).forEach(element => {
        giftsTotal += parseFloat(element.getAttribute('data-price'))
    });

    let sizeRadio = addToCartForm.querySelector('input[name="size"][type="radio"]:checked');
    if (sizeRadio) {
        multiplier = parseFloat(sizeRadio.value);
    }

    let total = roundToDecimal(price * multiplier + giftsTotal);

    priceData.innerHTML = `${total} ${currencyCode}`;

    console.log(total);
}

module.exports = {
    VERSION: VERSION,
    NAME: NAME,

    init: init,
};